import { z } from 'zod';

export const policySchema = z.object({
  id: z.string(),
  abilities: z.record(z.string(), z.union([z.boolean(), z.array(z.string())])),
});

export type PolicySchema = z.infer<typeof policySchema>;
